import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import api from '../api/axios';

// 异步thunk用于语法检查
export const checkGrammar = createAsyncThunk(
  'grammar/checkGrammar',
  async (text, { rejectWithValue }) => {
    try {
      const response = await api.post('/grammar-check', { text });
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.error || '语法检查失败，请稍后重试'
      );
    }
  }
);

// 异步thunk用于单词查询
export const queryWord = createAsyncThunk(
  'grammar/queryWord',
  async (word, { rejectWithValue }) => {
    try {
      const response = await api.get(`/word-define/${word}`);
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.error || '单词查询失败，请稍后重试'
      );
    }
  }
);

const grammarSlice = createSlice({
  name: 'grammar',
  initialState: {
    inputText: '',
    result: null,
    wordResult: null, // 新增：用于存储单词查询结果
    isChinese: false,
    loading: false,
    error: null,
    history: []
  },
  reducers: {
    setInputText: (state, action) => {
      state.inputText = action.payload;
    },
    clearResult: (state) => {
      state.result = null;
      state.wordResult = null; // 新增：清空单词查询结果
      state.isChinese = false;
      state.error = null;
    },
    clearError: (state) => {
      state.error = null;
    },
    clearWordResult: (state) => {
      state.wordResult = null; // 新增：单独清空单词查询结果
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(checkGrammar.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(checkGrammar.fulfilled, (state, action) => {
        state.loading = false;
        state.result = action.payload;
        state.isChinese = action.payload.isChinese || false;
        state.history.unshift({
          id: Date.now(),
          timestamp: new Date().toISOString(),
          ...action.payload
        });
        // 保持历史记录最多10条
        if (state.history.length > 10) {
          state.history = state.history.slice(0, 10);
        }
      })
      .addCase(checkGrammar.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      // 新增：单词查询相关的 reducer
      .addCase(queryWord.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(queryWord.fulfilled, (state, action) => {
        state.loading = false;
        state.wordResult = action.payload;
      })
      .addCase(queryWord.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  }
});

export const { setInputText, clearResult, clearError, clearWordResult } = grammarSlice.actions;
export default grammarSlice.reducer;